// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Link$Showside from "./Link.bs.js";
import * as MetaTags$Showside from "../utils/MetaTags.bs.js";
import * as IconTiktok$Showside from "../icons/IconTiktok.bs.js";
import * as IconTwitter$Showside from "../icons/IconTwitter.bs.js";
import * as IconYoutube$Showside from "../icons/IconYoutube.bs.js";
import * as StringUtils$Showside from "../utils/StringUtils.bs.js";
import * as IconFacebook$Showside from "../icons/IconFacebook.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as IconInstagram$Showside from "../icons/IconInstagram.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as MarketsDropdown_Lazy$Showside from "./MarketsDropdown_Lazy.bs.js";
var tertiary = "#F4F4F5";
function ProfileHeader$Logo(Props) {
  var url = Props.url;
  var alt = Props.alt;
  return React.createElement(DataAttribute$Showside.make, {
    dataTestId: "profile-header-logo",
    children: React.createElement("img", {
      className: CSS$Showside.prefix("rounded-full object-cover"),
      style: {
        border: "1px solid " + tertiary + "",
        height: "96px",
        width: "96px"
      },
      alt: alt,
      src: url
    })
  });
}
ProfileHeader$Logo.displayName = "ProfileHeader.Logo";
var Logo = {
  make: ProfileHeader$Logo
};
function keepNonEmpty(networks) {
  return Belt_Array.keep(networks, function (network) {
    return network._0.trim() !== "";
  });
}
function getUrlFromNetwork(link) {
  switch (link.TAG | 0) {
    case /* Instagram */0:
      return StringUtils$Showside.safeConcat("https://instagram.com/", link._0);
    case /* Tiktok */1:
      return StringUtils$Showside.safeConcat("https://tiktok.com/", StringUtils$Showside.safeConcat("@", link._0));
    case /* Twitter */2:
      return StringUtils$Showside.safeConcat("https://twitter.com/", link._0);
    case /* Facebook */3:
      return StringUtils$Showside.safeConcat("https://facebook.com/", link._0);
    case /* Youtube */4:
      return StringUtils$Showside.safeConcat("https://youtube.com/", StringUtils$Showside.safeConcat("@", link._0));
  }
}
function ProfileHeader$SocialNetworks(Props) {
  var networks = Props.networks;
  var onClick = Props.onClick;
  return React.createElement(DataAttribute$Showside.make, {
    dataTestId: "profile-header-social-links",
    children: React.createElement("div", {
      className: CSS$Showside.prefix("flex items-center justify-center w-full space-x-8")
    }, keepNonEmpty(networks).map(function (network, idx) {
      var className = CSS$Showside.prefix("text-primary");
      switch (network.TAG | 0) {
        case /* Instagram */0:
          return React.createElement(Link$Showside.make, {
            children: React.createElement(IconInstagram$Showside.make, {}),
            href: getUrlFromNetwork(network),
            unstyled: true,
            className: className,
            onClick: onClick,
            key: String(idx)
          });
        case /* Tiktok */1:
          return React.createElement(Link$Showside.make, {
            children: React.createElement(IconTiktok$Showside.make, {}),
            href: getUrlFromNetwork(network),
            unstyled: true,
            className: className,
            onClick: onClick,
            key: String(idx)
          });
        case /* Twitter */2:
          return React.createElement(Link$Showside.make, {
            children: React.createElement(IconTwitter$Showside.make, {}),
            href: getUrlFromNetwork(network),
            unstyled: true,
            className: className,
            onClick: onClick,
            key: String(idx)
          });
        case /* Facebook */3:
          return React.createElement(Link$Showside.make, {
            children: React.createElement(IconFacebook$Showside.make, {}),
            href: getUrlFromNetwork(network),
            unstyled: true,
            className: className,
            onClick: onClick,
            key: String(idx)
          });
        case /* Youtube */4:
          return React.createElement(Link$Showside.make, {
            children: React.createElement(IconYoutube$Showside.make, {}),
            href: getUrlFromNetwork(network),
            unstyled: true,
            className: className,
            onClick: onClick,
            key: String(idx)
          });
      }
    }))
  });
}
ProfileHeader$SocialNetworks.displayName = "ProfileHeader.SocialNetworks";
var SocialNetworks = {
  make: ProfileHeader$SocialNetworks
};
function ProfileHeader(Props) {
  var config = Props.config;
  var match = EntrypointContext$Showside.use(undefined);
  var trackEvent = match.trackEvent;
  var onSocialNetworkLinkClicked = function (param) {
    Curry.app(trackEvent, ["mkrbio:link_clicked", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  };
  var onCTAClicked = function (param) {
    Curry.app(trackEvent, ["mkrbio:cta_clicked", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
  };
  var callToAction = config.callToAction;
  return React.createElement("div", {
    className: CSS$Showside.prefix("relative bg-main")
  }, React.createElement(MetaTags$Showside.make, {}), React.createElement(MarketsDropdown_Lazy$Showside.make, {
    className: CSS$Showside.prefix("relative flex justify-end mr-4")
  }), React.createElement("div", {
    className: CSS$Showside.prefix("flex flex-col items-center mx-auto text-center"),
    style: {
      maxWidth: "430px",
      padding: "24px 16px 20px"
    }
  }, React.createElement(ConditionalRender$Showside.When.make, {
    condition: config.logoUrl !== "",
    children: React.createElement(ProfileHeader$Logo, {
      url: config.logoUrl,
      alt: "Profile logo"
    })
  }), React.createElement(ConditionalRender$Showside.When.make, {
    condition: config.name !== undefined,
    children: React.createElement(DataAttribute$Showside.make, {
      dataTestId: "profile-header-name",
      children: React.createElement("p", {
        className: CSS$Showside.prefix("mt-4 font-semibold text-3xl text-primary")
      }, Belt_Option.getWithDefault(config.name, ""))
    })
  }), React.createElement(ConditionalRender$Showside.When.make, {
    condition: config.description !== undefined,
    children: React.createElement(DataAttribute$Showside.make, {
      dataTestId: "profile-header-description",
      children: React.createElement("p", {
        className: CSS$Showside.prefix("mt-4 text-secondary"),
        style: {
          fontSize: "14px",
          fontWeight: "300"
        }
      }, Belt_Option.getWithDefault(config.description, ""))
    })
  }), React.createElement(ConditionalRender$Showside.When.make, {
    condition: config.socialNetworksLinks.length > 0,
    children: React.createElement("div", {
      style: {
        marginTop: "16px"
      }
    }, React.createElement(ProfileHeader$SocialNetworks, {
      networks: config.socialNetworksLinks,
      onClick: onSocialNetworkLinkClicked
    }))
  }), callToAction !== undefined ? React.createElement(Link$Showside.make, {
    children: callToAction.label,
    href: callToAction.url,
    unstyled: true,
    className: CSS$Showside.prefix(Cn.make(["border-solid border-2 border-primary text-primary", "w-full", "bg-main", "flex items-center justify-center ", "text-lg font-semibold drop-shadow-sm cursor-pointer", "font-semibold", "shadow-hard-edge hover:shadow-hard-edge-lg"])),
    style: {
      fontSize: "14px",
      height: "44px",
      lineHeight: "14px",
      marginTop: "16px",
      textDecoration: "none"
    },
    dataTestId: "profile-header-cta-button",
    onClick: onCTAClicked
  }) : null));
}
ProfileHeader.displayName = "ProfileHeader";
var make = ProfileHeader;
var $$default = ProfileHeader;
export { tertiary, Logo, keepNonEmpty, getUrlFromNetwork, SocialNetworks, make, $$default, $$default as default };
/* react Not a pure module */